import { Action } from 'redux';

import { IContentInfo } from '../../../ts/models/IContentInfo';
import { NewPredictiveModelForDatasource } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface NewPredictiveModelForDatasourceAction extends Action {
  contentInfo: IContentInfo;
}

export function newPredictiveModelForDatasource(contentInfo: IContentInfo): NewPredictiveModelForDatasourceAction {
  return {
    type: NewPredictiveModelForDatasource,
    contentInfo
  };
}

export const isNewPredictiveModelForDatasourceAction = isActionFactory<NewPredictiveModelForDatasourceAction>(NewPredictiveModelForDatasource);
